import {CdAddedMeasure} from '../../../interfaces/care/cd-care-plan/cd-added-measure';
import {CdNandaMeasure} from '../../../interfaces/care/cd-nanda/cd-nanda-measure';
import {CdAddedMeasureDetail} from '../../../interfaces/care/cd-care-plan/cd-added-measure-detail';
import {CdAddedMeasureDetailFactory} from './cd-added-measure-detail-factory';
import {CdFrequency} from '../../../interfaces/care/cd-care-plan/cd-frequency';
import {CdFrequencyFactory} from './cd-frequency-factory';

export class CdAddedMeasureFactory {

  /**
   *
   * @param cdAddedMeasure
   */
  public static fromObject(cdAddedMeasure: any): CdAddedMeasure {
    return new class implements CdAddedMeasure {
      cdCarePlanId: number = cdAddedMeasure.c_care_plan_id;
      cdClarificationId: number = cdAddedMeasure.c_clarification_id;
      cdNandaMeasure: CdNandaMeasure = {
        id: cdAddedMeasure.c_care_plan_item_able_id,
        name: (cdAddedMeasure.name ?? cdAddedMeasure.definition)
      };
      comment: string = cdAddedMeasure.comment;
      created: string = cdAddedMeasure.created;
      id: number = cdAddedMeasure.id;
      itemNumber: number = cdAddedMeasure.item_number;
      itemNumberString: string = cdAddedMeasure.item_number_string;
      modified: string = cdAddedMeasure.modified;
      parentId: number = cdAddedMeasure.parent_id;
      type: 'measure' = cdAddedMeasure.type;
      userId: number = cdAddedMeasure.user_id;
      isPfa: boolean = cdAddedMeasure.is_pfa;
      cdAddedMeasureDetails: CdAddedMeasureDetail[] =
        cdAddedMeasure.measure_details ? CdAddedMeasureDetailFactory.fromArray(cdAddedMeasure.measure_details) : [];
      alternativeText: string = cdAddedMeasure.measure_alternative_text;
      cdFrequencies: CdFrequency[] = cdAddedMeasure.c_frequencies ? CdFrequencyFactory.fromArray(cdAddedMeasure.c_frequencies) : [];
    };
  }

  /**
   *
   * @param cdAddedMeasures
   */
  public static fromArray(cdAddedMeasures: any[]): CdAddedMeasure[] {
    return cdAddedMeasures.map(_cdAddedMeasure => CdAddedMeasureFactory.fromObject(_cdAddedMeasure));
  }


}
